import React from "react";
import { Card, Tag, Space } from "antd";
import { RobotOutlined } from "@ant-design/icons";
import { formatDistance } from "date-fns";
import { it } from "date-fns/locale";
import InputPreview from "./InputPreview";
import OutputPreview from "./OutputPreview";

// Il provider/modello LLM è coinvolto SOLO nelle richieste OCR (requestType "ID_OCR"):
// le richieste "ID" producono solo un PDF e non passano da alcun LLM, quindi per quelle
// non mostriamo il tag. I record OCR storici (precedenti all'introduzione del provider su
// doc-scanner) non hanno i campi: in quel caso il modello usato era OpenAI con gpt-4o.
const DEFAULT_LLM_PROVIDER = "OpenAI";
const DEFAULT_LLM_MODEL = "gpt-4o";

const PROVIDER_LABELS = {
  openai: "OpenAI",
  anthropic: "Anthropic",
};

const PROVIDER_COLORS = {
  openai: "green",
  anthropic: "volcano",
};

const formatProvider = (provider) => {
  if (!provider) return DEFAULT_LLM_PROVIDER;
  const key = provider.toLowerCase();
  return PROVIDER_LABELS[key] || provider;
};

const DocScannerCard = ({
  resultPdf,
  createdAt,
  input,
  resultJson,
  error,
  code,
  orgLink,
  llmProvider,
  llmModel,
}) => {
  // Solo le richieste OCR ("ID_OCR") usano un LLM; le "ID" generano solo un PDF.
  const isOcr = code === "ID_OCR";
  const providerLabel = formatProvider(llmProvider);
  const modelLabel = llmModel || DEFAULT_LLM_MODEL;
  const providerColor =
    PROVIDER_COLORS[(llmProvider || "").toLowerCase()] || "green";
  return (
    <div className="grid-item">
      <Card
        extra={
          <Space>
            {resultPdf && (
              <a
                href={resultPdf}
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontSize: "1.2em" }}
              >
                Apri
              </a>
            )}
            {resultPdf && orgLink && " | "}
            {orgLink && (
              <a
                href={orgLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontSize: "1.2em" }}
              >
                Org
              </a>
            )}
          </Space>
        }
        style={{
          border: error && "2px solid #ff4d4f",
        }}
      >
        <div style={{ maxWidth: "100%" }}>
          <InputPreview input={input} />
          <OutputPreview
            resultPdf={resultPdf}
            resultJson={resultJson}
            code={code}
            error={error}
          />
        </div>
        <Space size={[8, 8]} wrap style={{ marginTop: "10px" }}>
          <Tag
            style={{
              background: "#fafafa",
              marginRight: "0px",
            }}
          >
            {formatDistance(new Date(createdAt * 1000), new Date(), {
              locale: it,
            })}
          </Tag>
          {isOcr && (
            <Tag
              color={providerColor}
              icon={<RobotOutlined />}
              style={{ marginRight: "0px" }}
            >
              {providerLabel} · {modelLabel}
            </Tag>
          )}
        </Space>
      </Card>
    </div>
  );
};

export default DocScannerCard;
